import React from "react";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Detail({ employee = {}, convertDateTime }) {
  // Hàm tạo địa chỉ đầy đủ
  const createFullAddress = (address, ward, province) => {
    let fullAddress = address || '';
    
    if (ward?.WardName) {
      fullAddress = fullAddress ? `${fullAddress} - ${ward.WardName}` : ward.WardName;
    }
    if (province?.ProvinceName) {
      fullAddress = fullAddress ? `${fullAddress} - ${province.ProvinceName}` : province.ProvinceName;
    }
    return fullAddress;
  };

  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("National")}</div>
            <div className="form-value">
            <span>{employee?.National?.NationalName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("CitizenIDNo")}</div>
            <div className="form-value">
              <span>{employee.CitizenIDNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("Citizen1stExpiredDate")}
            </div>
            <div className="form-value">
              <span>
                {convertDateTime(
                  convertDateTime(employee.CitizenExpiredDateFirstTime)
                )}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("IdNo")}</div>
            <div className="form-value">
              <span>{employee?.IDNo}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("HometownAddress")}</div>
            <div className="form-value">
            <span>{createFullAddress(employee?.HometownAddress, employee?.HometownWard, employee?.HomeTownProvince, employee?.HomeTown)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Email")}</div>
            <div className="form-value">
              <span>{employee?.Email}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("CitizenIDIssueDate")}
            </div>
            <div className="form-value">
              <span>
                {convertDateTime(employee?.CitizenIDIssueDate)}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("CitizenExpiredDate2nd")}
            </div>
            <div className="form-value">
              <span>
                {
                  convertDateTime(employee?.CitizenExpiredDateSecondTime
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("IDIssueDate")}</div>
            <div className="form-value">
              <span>
                {convertDateTime(employee?.IDIssueDate)}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("HometownProvince")}
            </div>
            <div className="form-value">
              <span>{employee?.HomeTown?.ProvinceName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("PhoneNumber")}</div>
            <div className="form-value">
              <span>{employee?.PhoneNumber}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("CitizenIDIssuePlace")}
            </div>
            <div className="form-value">
              <span>{employee?.CitizenIDPlace}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">
              {formatMessage("CitizenExpiredDate3rd")}
            </div>
            <div className="form-value">
              <span>
                {convertDateTime(employee?.CitizenExpiredDateThirdTime)}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("IDIssuePlace")}</div>
            <div className="form-value">
              <span>{employee?.IDPlace}</span>
            </div>
          </div>
        </div>
      </div>
      {/*Địa chỉ nguyên quán*/}
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("HometownAddress")}</div>
            <div className="form-value">
              <span>{createFullAddress(employee?.HometownAddress, employee?.HometownWard, employee?.HomeTownProvince, employee?.HomeTown)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
          <div className="form-label">{formatMessage("HometownProvince")}</div>
            <div className="form-value">
              <span>{employee?.HomeTown?.ProvinceName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("HometownWard")}</div>
            <div className="form-value">
              <span>{employee?.HometownWard?.WardName}</span>
            </div>
          </div>
        </div>
      </div>
      {/*Địa chỉ nơi sinh*/}
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("BirthAddress")}</div>
            <div className="form-value">
              <span>{createFullAddress(employee?.BirthAddress, employee?.BirthWard, employee?.BirthProvince)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
          <div className="form-label">{formatMessage("BirthProvince")}</div>
            <div className="form-value">
              <span>{employee?.BirthProvince?.ProvinceName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("BirthWard")}</div>
            <div className="form-value">
              <span>{employee?.BirthWard?.WardName}</span>
            </div>
          </div>
        </div>
      </div>
      {/*Địa chỉ thường trú*/}
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("NativeAddress")}</div>
            <div className="form-value">
              <span>{createFullAddress(employee?.NativeAddress, employee?.NativeWard, employee?.NativeProvince)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("NativeProvince")}</div>
            <div className="form-value">
              <span>{employee?.NativeProvince?.ProvinceName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("NativeWard")}</div>
            <div className="form-value">
              <span>{employee?.NativeWard?.WardName}</span>
            </div>
          </div>
        </div>
      </div>
      {/*Địa chỉ Tạm trú*/}
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">
              {formatMessage("TemporaryAddress")}
            </div>
            <div className="form-value">
              <span>{createFullAddress(employee?.TemporaryAddress, employee?.TemporaryWard, employee?.TemporaryProvince)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("TemporaryProvince")}</div>
            <div className="form-value">
              <span>{employee?.TemporaryProvince?.ProvinceName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("TemporaryWard")}</div>
            <div className="form-value">
              <span>{employee?.TemporaryWard?.WardName}</span>
            </div>
          </div>
        </div>
      </div>


      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("PassportNo")}</div>
            <div className="form-value">
              <span>{employee?.PassportNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("PassportEffectDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.PassportEffectDate)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("MaritalStatus")}</div>
            <div className="form-value">
              <span>{employee?.MaritalStatus}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("PassportExpireDate")}
            </div>
            <div className="form-value">
              {convertDateTime(employee?.PassportExpireDate)}
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("Ethnic")}</div>
            <div className="form-value">{employee?.Ethnic?.EthnicName}</div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Religion")}</div>
            <div className="form-value">
              <span>{employee?.Religion?.ReligionName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          
        </div>
      </div>
    </div>
  );
}
